"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value instanceof Map;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isMap.js
// module id = 316
// module chunks = 0